<template>
  <v-navigation-drawer v-model="drawer" clipped app outlined>
    <v-list>
      <v-list-item to="/dashboard" exact>
        <v-list-item-icon>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Panel </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group prepend-icon="mdi-car" :value="false">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Vehiculos</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item to="/new-vehicule">
          <v-list-item-icon>
            <v-icon>mdi-car</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Nuevo Vehiculo</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/report-vehicules">
          <v-list-item-icon>
            <v-icon>mdi-car-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Reporte de Vehiculos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-divider />

      <v-list-group prepend-icon="mdi-tools" :value="false">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Herramientas</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item to="/new-tool">
          <v-list-item-icon>
            <v-icon>mdi-tools</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Nueva herramienta</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/report-tool">
          <v-list-item-icon>
            <v-icon>mdi-hammer-wrench</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Reporte de herramientas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-divider />

      <v-list-group prepend-icon="mdi-account-group" :value="false">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Empleados</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item to="/new-employee">
          <v-list-item-icon>
            <v-icon>mdi-account-hard-hat-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Nuevo empleado</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/report-employee">
          <v-list-item-icon>
            <v-icon>mdi-account-details</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Reporte de empleados</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-divider />

      <v-list-group prepend-icon="mdi-cash-multiple" :value="false">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Nomina</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item to="/new-payroll">
          <v-list-item-icon>
            <v-icon>mdi-cash-clock</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Nueva Nomina</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin-payroll">
          <v-list-item-icon>
            <v-icon>mdi-credit-card-settings-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Administrar Nomina</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin-percentage">
          <v-list-item-icon>
            <v-icon>mdi-currency-usd</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Administrar Porcentajes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-divider />

      <v-list-group prepend-icon="mdi-home-city" :value="false">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Alquileres</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item to="/new-rental">
          <v-list-item-icon>
            <v-icon>mdi-home-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Nuevo Alquiler</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/report-rental">
          <v-list-item-icon>
            <v-icon>mdi-home-group-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Reporter de Alquiler</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
      </v-list-group>

      <v-divider />

      <v-list-group prepend-icon="mdi-currency-usd" :value="false">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Gastos</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item to="/new-spent">
          <v-list-item-icon>
            <v-icon>mdi-currency-usd-off</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Nuevo gasto</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin-spent">
          <v-list-item-icon>
            <v-icon>mdi-cash-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Administrar gastos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>


      <v-divider />

      <v-list-group prepend-icon="mdi-rocket" :value="false">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Misiones</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item to="/new-mission">
          <v-list-item-icon>
            <v-icon>mdi-account-check-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Nueva mision</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin-mission">
          <v-list-item-icon>
            <v-icon>mdi-account-child</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Administrar misiones</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-divider />


      <v-list-group prepend-icon="mdi-alert-circle-outline" :value="false">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Inconvenientes</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item to="/new-item">
          <v-list-item-icon>
            <v-icon>mdi-account-question-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Nuevo inconveniente</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin-item">
          <v-list-item-icon>
            <v-icon>mdi-account-question</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Admin. inconvenientes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-divider />

      <v-list-group prepend-icon="mdi-shoe-sneaker" :value="false">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Corredores</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item to="/new-runner">
          <v-list-item-icon>
            <v-icon>mdi-shoe-sneaker</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Nuevo corredor</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/admin-runner">
          <v-list-item-icon>
            <v-icon>mdi-run-fast</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Reporte de corredores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

    </v-list>
  </v-navigation-drawer>
</template>

<script>
import bus from "../../events/bus";

export default {
  data() {
    return {
      drawer: true,
    };
  },

  beforeMount() {
    bus.$on("changeDrawer", () => {
      this.drawer = !this.drawer;
    });
  },
};
</script>

<style></style>
